import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const VersionHistory = ({ projectId, currentVersionId, onRestore }) => {
    const [versions, setVersions] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchVersions = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await api.get(`/api/versions/project/${projectId}`);
            setVersions(data);
        } catch (error) {
            toast.error('Failed to load version history');
        } finally {
            setLoading(false);
        }
    }, [projectId]);

    useEffect(() => {
        fetchVersions();
    }, [fetchVersions]);

    const handleRestore = async (versionId) => {
        try {
            toast.loading('Restoring version...', { id: 'restore' });
            const { data } = await api.post(`/api/versions/${versionId}/restore`);
            toast.success('Version restored!', { id: 'restore' });
            if (onRestore) {
                onRestore(data);
            } else {
                navigate(`/projects/${projectId}/versions/${data.id}`);
            }
        } catch (error) {
            toast.error('Failed to restore version', { id: 'restore' });
        }
    };

    if (loading) return <div>Loading history...</div>;

    return (
        <div className="version-history">
            <h3>Version History</h3>
            <div className="version-list">
                {versions.map((v) => (
                    <div key={v.id} className={`version-item ${v.id === parseInt(currentVersionId) ? 'active' : ''}`}>
                        <div className="version-item__info">
                            <span className="version-number">v{v.version_number}</span>
                            <span className="version-separator"> - </span>
                            <span className="version-date">{new Date(v.created_at).toLocaleString()}</span>
                            <p className="version-summary">{v.change_summary || 'No summary'}</p>
                            {v.has_merge_report && <p className="muted">Merge report available</p>}
                        </div>
                        <div className="version-item__actions">
                            {v.id !== parseInt(currentVersionId) && (
                                <>
                                    <button className="btn btn--sm" onClick={() => navigate(`/projects/${projectId}/versions/${v.id}`)}>
                                        View
                                    </button>
                                    <button className="btn btn--sm btn--primary" onClick={() => handleRestore(v.id)}>
                                        Restore
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VersionHistory;
